export default __webpack_public_path__ + "img/pin_icons/light_bulb_w.png";